import axios from "axios";
import {
  stripCategoryCodesFromCatalog,
  stripCategoryCodesFromContent,
} from "./categories";
var ObjectID = require("bson-objectid");

export let createdBy;
export let createdAt;

export async function displayDoc() {
  // Fetch document from API
  try {
    const response = await axios.get(`/api/documents/${this.state.docId}`, {
      params: { collection: this.props.collection }
    });

    const doc = response.data;

    if (!doc) {
      this.setState({ error: "SOW not found" });
      document.querySelector("#app-container").classList.remove("doc-view");
      return false;
    }

    document.querySelector("#app-container").classList.add("doc-view");
    this.injectDocState(doc, () => {
      this.setState({
        dirty: false,
      });
      createdBy = doc.createdBy;
      createdAt = new Date(doc._id); // Approximate timestamp from ObjectId

      if (this.props.pdf) {
        this.togglePreview();
      }

      if (!this.props.token) {
        let recent =
          JSON.parse(localStorage.getItem("recently-viewed")) || [];

        recent = recent.filter((d) => d.id !== this.state.docId);

        recent.unshift({
          id: this.state.docId,
          title: this.state.title,
        });

        localStorage.setItem(
          "recently-viewed",
          JSON.stringify(recent.slice(0, 10))
        );

        this.props.updateRecentlyViewed(recent.slice(0, 10));
      }
    });

    // Fetch revision count and history
    const revCountResponse = await axios.get(`/api/documents/${this.state.docId}/revisions/count`);
    this.setState({
      totalRevisions: revCountResponse.data.count,
    });

    const revisionsResponse = await axios.get(`/api/documents/${this.state.docId}/revisions`, {
      params: {
        limit: this.state.revisionLimit,
        skip: 0
      }
    });

    this.setState({
      revisions: revisionsResponse.data.revisions,
    });

    return doc;
  } catch (err) {
    console.error("Error fetching document:", err);
    this.setState({ error: "Failed to load document" });
  }
}

export function checkToken() {
  if (this.props.token) {
    axios
      .get(`/api/documents/${this.state.docId}`, {
        params: { collection: this.props.collection }
      })
      .then((response) => {
        const doc = response.data;
        if (this.props.token && this.props.token !== doc.token) {
          this.setState({
            error: "You are not authorized to view this document",
          });
          return false;
        } else {
          this.displayDoc();
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          error: "Failed to verify authorization",
        });
      });
  } else {
    this.displayDoc();
  }
}

export function loadMoreRevisions() {
  this.setState(
    {
      revisionLimit: this.state.revisionLimit + 5,
      loadingMoreRevisions: true,
    },
    () => {
      axios
        .get(`/api/documents/${this.state.docId}/revisions`, {
          params: {
            limit: this.state.revisionLimit,
            skip: 0
          }
        })
        .then((response) => {
          this.setState({
            revisions: response.data.revisions,
            loadingMoreRevisions: false,
          });
        })
        .catch((err) => {
          console.error("Error loading revisions:", err);
          this.setState({
            loadingMoreRevisions: false,
          });
        });
    }
  );
}

export function fetchCurrencyRates() {
  this.setState(
    {
      loaded: true,
    },
    () => {
      this.injectCompany();
      this.injectVariables();
      this.injectDeliverables();
      this.injectPayment();
    }
  );
}

export function displayDocOnLoad() {
  this.displayDoc()
    .then((doc) => {
      if (!doc) return;

      Promise.all([this.fetchTeam(doc), this.fetchCategories()]).then(() => {
        this.setState({
          loaded: true,
        });
      });
    })
    .catch(console.error);
}

function selectIds(value) {
  if (!value) return [];
  const list = Array.isArray(value) ? value : [value];
  return list.map((item) => item?.value).filter(Boolean);
}

function referencedMemberIds(state) {
  const ids = [
    ...selectIds(state.salesPerson),
    ...selectIds(state.accountManagement),
    ...selectIds(state.fromMember),
  ];

  if (state.team && typeof state.team === "object") {
    Object.keys(state.team).forEach((key) => {
      if (state.team[key] && key.startsWith("member-")) {
        ids.push(key.slice("member-".length));
      }
    });
  }

  return [...new Set(ids.map(String))];
}

export function documentMembers(state) {
  const active = state.members || [];
  const extra = state.referencedMembers || [];
  const seen = new Set(active.map((member) => String(member._id)));

  return active.concat(
    extra.filter((member) => !seen.has(String(member._id)))
  );
}

export function fetchTeam(doc) {
  return axios
    .get("/api/members")
    .then(async (response) => {
      const members = response.data;
      const loaded = new Set(members.map((member) => String(member._id)));
      const missing = referencedMemberIds(doc || this.state).filter(
        (id) => !loaded.has(id)
      );
      const referencedMembers = (
        await Promise.all(
          missing.map((id) =>
            axios
              .get(`/api/members/${id}`)
              .then((res) => res.data)
              .catch(() => null)
          )
        )
      ).filter(Boolean);

      let nt = '';
      if(this.state.type === "disAMR") {
        nt = members.find((m) => m.id === "5d3f5acdbb93c625ea71c798")
          ?.disamrTitle;
      } else {
        nt = members.find((m) => m.id === "5d3f5acdbb93c625ea71c798")
        ?.disamrTitle;
      }
      this.setState({
        members,
        referencedMembers,
        nigelTitle: nt,
      });
    })
    .catch((err) => {
      console.error("Error fetching team:", err);
    });
}

export function fetchCategories() {
  return axios
    .get("/api/categories")
    .then((response) => {
      const result = response.data;
      const stripCodes = this.state.type === "disAMR";
      const catalog = result[0]?.data || [];
      const deliverableCategories = stripCodes
        ? stripCategoryCodesFromCatalog(catalog)
        : catalog;
      const nextState = { deliverableCategories };

      if (stripCodes) {
        const strippedContent = stripCategoryCodesFromContent(this.state.content);
        if (strippedContent !== this.state.content) {
          nextState.content = strippedContent;
        }
      }

      this.setState(nextState, () => {
        this.injectDeliverables();
      });
    })
    .catch((err) => {
      console.error("Error fetching categories:", err);
    });
}
